import { useState } from "react";
import { useMutation } from "@apollo/client/react";
import {
  AttachProductImageDocument,
  MyProductDocument,
  RemoveProductImageDocument,
  ReorderProductImagesDocument,
} from "@/generated/graphql";
import { graphQLErrorMessage } from "@/lib/graphqlErrors";

export function useProductImages(productId: string) {
  const [error, setError] = useState<string | null>(null);

  const refetchProduct = [{ query: MyProductDocument, variables: { id: productId } }];

  const [attachMutation, { loading: attaching }] = useMutation(AttachProductImageDocument, {
    refetchQueries: refetchProduct,
  });

  const [removeMutation, { loading: removing }] = useMutation(RemoveProductImageDocument, {
    refetchQueries: refetchProduct,
  });

  const [reorderMutation, { loading: reordering }] = useMutation(ReorderProductImagesDocument, {
    refetchQueries: refetchProduct,
  });

  const attachImage = (file: File) => {
    setError(null);
    attachMutation({
      variables: { input: { productId, file } },
      onError: (err) =>
        setError(graphQLErrorMessage(err, "Não foi possível enviar a imagem.")),
    });
  };

  const removeImage = (productImageId: string) => {
    setError(null);
    removeMutation({
      variables: { input: { productImageId } },
      onError: (err) =>
        setError(graphQLErrorMessage(err, "Não foi possível remover a imagem.")),
    });
  };

  const reorderImages = (imageIds: string[]) => {
    setError(null);
    reorderMutation({
      variables: { input: { productId, imageIds } },
      onError: (err) =>
        setError(graphQLErrorMessage(err, "Não foi possível reordenar as imagens.")),
    });
  };

  return {
    attachImage,
    removeImage,
    reorderImages,
    attaching,
    removing,
    reordering,
    loading: attaching || removing || reordering,
    error,
    clearError: () => setError(null),
  };
}
